import $ from 'jquery';
import 'slick-carousel';

/**
 * Class representing an image gallery slider.
 */
export class ImageGallery {
    /** @type {jQuery} */
    gallery = $();

    /**
     * Create an ImageGallery instance.
     *
     * @param {HTMLElement} element - The HTML element representing the gallery.
     */
    constructor(element) {
        this.gallery = $(element);

        if (this.gallery.length > 0) {
            this.initSliderDefault(this.gallery);
        }
    }

    /**
     * Set the vertical position of the navigation buttons for a single slide.
     *
     * @param {jQuery} gallery - The gallery element.
     * @param {number} slideIndex - The index of the slide.
     */
    setButtonPositionSingle(gallery, slideIndex) {
        const buttonPrev = gallery.find('.slick-prev');
        const buttonNext = gallery.find('.slick-next');
        const image = gallery.find(`[data-slick-index="${slideIndex}"] img`);
        const buttonPosition = Math.round(image.height() / 2);

        buttonNext.css('top', buttonPosition);
        buttonPrev.css('top', buttonPosition);
    }

    /**
     * Initialize the slider with default settings.
     *
     * @param {jQuery} gallery - The gallery element.
     */
    initSliderDefault(gallery) {
        const slider = gallery.find('.elements');

        if (slider.length === 0) {
            return;
        }

        $(window).on('resize.gallery', () => {
            setTimeout(() => {
                const currentSlideIndex = gallery.find('.slick-current').data('slick-index');
                this.setButtonPositionSingle(gallery, currentSlideIndex);
            }, 300);
        });

        slider.on('init', () => {
            this.setButtonPositionSingle(gallery, 0);

            const slide = gallery.find('[data-slick-index="0"]');
            setTimeout(() => {
                slide.addClass('slide-active');
                slider.addClass('slider-initialized');
            }, 500);
        });

        slider.find('img').on('load', () => {
            this.setButtonPositionSingle(gallery, 0);
        });

        slider.on('afterChange', (event, slick, currentSlide) => {
            const allSlides = gallery.find('.slick-slide');
            const slide = gallery.find(`[data-slick-index="${currentSlide}"]`);

            allSlides.removeClass('slide-active');
            setTimeout(() => {
                slide.addClass('slide-active');
            }, 200);
        });

        slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.setButtonPositionSingle(gallery, nextSlide);
        });

        slider.slick({
            adaptiveHeight: true,
            touchThreshold: 8,
            swipeToSlide: true
        });
    }
}
